// Qualified, consent-aware news measurements. No customer identity, referrer or IP is sent.
if (!window.flopNewsAnalytics && !window.Shopify?.designMode && !new URLSearchParams(location.search).has('preview_theme_id')) {
  window.flopNewsAnalytics = true;
  const endpoint = '/apps/floptropica-news/analytics';
  const tracked = new Map();
  const queued = new Map();
  let session, sent = new Set(), expires = 0, timer;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  function identity() {
    if (Date.now() < expires && session) return;
    let stored;
    try { stored = JSON.parse(sessionStorage.getItem('flop-news-session') || 'null'); } catch { /* Storage can be unavailable. */ }
    session = stored?.expires > Date.now() ? stored.id : crypto.randomUUID();
    expires = stored?.expires > Date.now() ? stored.expires : Date.now() + 1800000;
    sent = new Set(stored?.expires > Date.now() ? stored.sent : []);
  }
  function event(element, kind) {
    if (!allowed()) return;
    identity();
    const articleId = element.dataset.newsArticle, surface = element.dataset.newsSurface;
    const key = [articleId, surface, kind].join(':');
    if (sent.has(key)) return;
    sent.add(key);
    try { sessionStorage.setItem('flop-news-session', JSON.stringify({id: session, expires, sent: [...sent].slice(-1000)})); } catch { /* Measurement still works for this page. */ }
    queued.set(key, {articleId, surface, kind});
    clearTimeout(timer); timer = setTimeout(flush, 2000);
  }
  function flush() {
    clearTimeout(timer);
    if (!allowed()) { queued.clear(); return; }
    const events = [...queued.values()].slice(0, 20);
    if (!events.length) return;
    const body = JSON.stringify({session, consent: true, device: matchMedia('(display-mode: standalone)').matches || navigator.standalone ? 'pwa' : matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop', events});
    events.forEach(e => queued.delete([e.articleId,e.surface,e.kind].join(':')));
    fetch(endpoint, {method: 'POST', headers: {'Content-Type': 'text/plain;charset=UTF-8'}, body, keepalive: true}).catch(() => {});
    if (queued.size) timer = setTimeout(flush, 2000);
  }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = tracked.get(entry.target);
      if (state) {
        state.visible = entry.isIntersecting && (entry.target.dataset.newsSurface === 'article' || entry.intersectionRatio >= 0.5);
        state.last = performance.now();
        if (!state.visible && entry.target.dataset.newsSurface !== 'article') state.seconds = 0;
      }
    });
  }, {threshold: [0, 0.5]});
  function scan() {
    document.querySelectorAll('[data-news-article]').forEach(element => {
      if (tracked.has(element)) return;
      tracked.set(element, {visible: false, seconds: 0, last: performance.now()}); observer.observe(element);
      if (element.dataset.newsSurface !== 'article') element.addEventListener('click', e => { if (e.target.closest('a')) { event(element, 'click'); flush(); } });
    });
  }
  const interval = setInterval(() => {
    tracked.forEach((state, element) => {
      const now = performance.now(), elapsed = Math.min(1000, now - state.last); state.last = now;
      if (!element.isConnected) { observer.unobserve(element); tracked.delete(element); return; }
      if (document.hidden || !allowed()) return;
      if (!state.visible) return;
      state.seconds += elapsed / 1000;
      const article = element.dataset.newsSurface === 'article';
      if (state.seconds >= (article ? 2 : 1)) event(element, article ? 'view' : 'impression');
      if (article && state.seconds >= 10) {
        event(element, 'engaged');
        const body = element.querySelector('.floptropican-news-story__body');
        if (body) { const rect = body.getBoundingClientRect(); if (innerHeight >= rect.top + rect.height * 0.75) event(element, 'complete'); }
      }
    });
  }, 1000);
  const consentChanged = () => { if (!allowed()) { queued.clear(); tracked.forEach(state => state.seconds = 0); try { sessionStorage.removeItem('flop-news-session'); } catch {} session = null; expires = 0; } };
  document.addEventListener('visitorConsentCollected', consentChanged);
  if (!window.Shopify?.customerPrivacy) window.Shopify?.loadFeatures?.([{name: 'consent-tracking-api', version: '0.1'}], () => {});
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('visibilitychange', () => { if (document.hidden) flush(); });
  window.addEventListener('pagehide', e => { flush(); if (!e.persisted) { clearInterval(interval); observer.disconnect(); } });
  scan();
}
